export const VerifyPath = "/verify";
export const PaymentPath = "/payment"

export const ShopDetail = "/barber";
